import React from 'react';

export interface OptimizedImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'loading'> {
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  loading = 'lazy',
  decoding = 'async',
  fetchPriority = 'auto',
  ...rest
}) => {
  return (
    <img
      loading={loading}
      decoding={decoding as any}
      fetchPriority={fetchPriority}
      {...rest}
    />
  );
};

export default OptimizedImage;
